import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'

import Field from '../../struct/Field'
import TagSourceField from '../../struct/TagSourceField'
import Checkbox from '../../control/DependentCheckbox'
import InputText from '../../control/DependentInputText'
import InputTextarea from '../../control/DependentInputTextarea'
import DatePicker from '../../control/DependentDatePicker'
import OfferFieldValueSourceSelect from '../offer/field_mapping/OfferFieldValueSourceSelect'

import styles from './ProfileBonusCardDiscountsSettings.less'

@observer export default class ProfileBonusCardDiscountsSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const form_state = context.form_state
        const profile = context.profile
        const discount = profile.promo_bonus_card_discount
        const options_groups_factory = context.value_source_options_groups_factory

        return (
            <div>
                <Field label="Цена по программе лояльности">
                    <Checkbox
                        checked={discount.is_enabled}
                        onChange={e => discount.is_enabled = e.target.checked}
                        state={form_state}
                    >
                        Включить
                    </Checkbox>
                </Field>

                {
                    discount.is_enabled ? (
                        <Fragment>
                            <Field className={styles['field-label']}>
                                Цена <span className={styles['field-required-label']}>*</span>
                            </Field>
                            <TagSourceField
                                tag={<Fragment>promo{'><'}purchase{'><'}product{'><'}discount-price</Fragment>}
                            >
                                <OfferFieldValueSourceSelect
                                    context={context}
                                    value_source={profile.promo_bonus_card_discount_value_source}
                                    field="bonus_card_discounts"
                                />
                            </TagSourceField>

                            <Field className={styles['field-label']}>
                                ID акции <span className={styles['field-required-label']}>*</span>
                            </Field>
                            <TagSourceField
                                tag={<Fragment>promo <b>id</b>="..."</Fragment>}
                                hint="Максимальная длина id — 20 символов"
                            >
                                <InputText
                                    value={discount.discount_id}
                                    onChange={e => discount.discount_id = e.target.value}
                                    state={form_state}
                                />
                            </TagSourceField>

                            <Field className={styles['field-label']}>
                                Краткое описание
                            </Field>
                            <TagSourceField
                                tag={<Fragment>promo{'><'}description</Fragment>}
                                hint="Краткое описание программы. Максимум 500 символов. Можно использовать XHTML-разметку"
                            >
                                <InputTextarea
                                    value={discount.description}
                                    onChange={e => discount.description = e.target.value}
                                    state={form_state}
                                />
                            </TagSourceField>

                            <Field className={styles['field-label']}>
                                Ссылка на описание <span className={styles['field-required-label']}>*</span>
                            </Field>
                            <TagSourceField
                                tag={<Fragment>promo{'><'}url</Fragment>}
                                hint="Ссылка на описание программы и условия участия в ней на сайте магазина"
                            >
                                <InputText
                                    value={discount.url}
                                    onChange={e => discount.url = e.target.value}
                                    state={form_state}
                                />
                            </TagSourceField>

                            <Field className={styles['field-label']}>
                                Срок действия акции <span className={styles['field-required-label']}>*</span>
                            </Field>
                            <TagSourceField tag={<Fragment>promo{'><'}start-date/end-date</Fragment>}>
                                <DatePicker
                                    selected={discount.start_date}
                                    onChange={date => discount.start_date = date}
                                    dateFormat="dd.MM.yyyy"
                                    className={styles['datepicker']}
                                    state={form_state}
                                />

                                <span className={styles['datepicker-separator']}>&mdash;</span>

                                <DatePicker
                                    selected={discount.end_date}
                                    onChange={date => discount.end_date = date}
                                    dateFormat="dd.MM.yyyy"
                                    className={styles['datepicker']}
                                    state={form_state}
                                />
                            </TagSourceField>
                        </Fragment>
                    ) : (null)
                }
            </div>
        )
    }
}